const CalendarIcon = () => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.79531 4.20771H3.09531C2.59826 4.20771 2.19531 4.61066 2.19531 5.10771V7.80771M5.79531 4.20771H12.9953M5.79531 4.20771V2.40771M12.9953 4.20771H15.6953C16.1924 4.20771 16.5953 4.61066 16.5953 5.10772V7.80771M12.9953 4.20771V2.40771M2.19531 7.80771V15.9077C2.19531 16.4048 2.59826 16.8077 3.09531 16.8077H6.95722H11.8334H15.6953C16.1924 16.8077 16.5953 16.4048 16.5953 15.9077V7.80771M2.19531 7.80771H9.39531H16.5953M5.4096 10.7649H6.18103M9.0096 10.7649H9.78103M12.6096 10.7649H13.381M5.4096 13.8506H6.18103M9.0096 13.8506H9.78103M12.6096 13.8506H13.381"
                stroke="#707070"
                stroke-width="1.4"
                stroke-linecap="round"
            />
        </svg>
    )
}

export default CalendarIcon
